import React from 'react'
import styled from '@emotion/styled'

export const PlaceText = ({ text }: { text: string }) => (
  <WrapperStyled>
    <span>{text}</span>
  </WrapperStyled>
)

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  minWidth: '5rem',

  '> span': {
    flexShrink: 0,
    textAlign: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
    padding: '0.3rem 0.7rem',
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: 1.2,
    wordWrap: 'normal',
    marginLeft: '-0.7rem',
    minWidth: 'fit-content',
    width: '4rem',
    borderRadius: '10rem',
  },
})
